



// slider国旗
$(function() {
    $('#slider').slick({ //メインのスライダーにしたい要素
          infinite: true, //スライドをループさせるか
          arrows: 0, //前後ボタンの表示
          dots: 0, //点の表示
          variableWidth: false, //横幅が異なるスライドにするか
          autoplay: true, //自動切り替え
          autoplaySpeed: 3000, //自動切り替えにかかる時間
          centerMode:0, //要素を中央へ
		  slidesToShow:1,
		  pauseOnHover:0,
          responsive: [{
               breakpoint: 768, // 横幅750px以下で挙動変更
                    settings: {
                         variableWidth: false,
						 initialSlide: 2,
                         centerMode: false
               }
          }]
     });
    
});
$(function() {
    $('#slider01').slick({
  infinite: true, //スライドをループさせるか
          arrows: 0, //前後ボタンの表示
          dots: 0, //点の表示
          variableWidth: true, //横幅が異なるスライドにするか
          autoplay: true, //自動切り替え
          autoplaySpeed: 3000, //自動切り替えにかかる時間
          centerMode: true, //要素を中央へ
		  pauseOnHover:0,

  responsive: [{
   breakpoint: 1065, // ブレイクポイントを指定
    settings: {
     variableWidth: true,
						 slidesToShow:1,
						 initialSlide: 2,
						 dots:1,
						 slidesToScroll:1,
                         centerMode: false,
    },
   },
  {
   breakpoint: 480,
    settings: {
     variableWidth: true,
						 slidesToShow:1,
						 initialSlide: 4,
						 slidesToScroll:1,
                         centerMode: false,
   },
  },
 ]
});
    
});
$(function() {
    $('#slider02').slick({ //メインのスライダーにしたい要素
          infinite: true, //スライドをループさせるか
          arrows: 0, //前後ボタンの表示
          dots: 0, //点の表示
          variableWidth: true, //横幅が異なるスライドにするか
          autoplay: true, //自動切り替え
          autoplaySpeed: 3000, //自動切り替えにかかる時間
          centerMode: true, //要素を中央へ
		  pauseOnFocus: false, //スライダーをフォーカスした時にスライドを停止させるか
          pauseOnHover: false, //スライダーにマウスホバーした時にスライドを停止させるか
          responsive: [{
               breakpoint: 768, // 横幅750px以下で挙動変更
                    settings: {
                         variableWidth: false,
						 initialSlide: 1,
						 autoplaySpeed: 5000,
                         centerMode: false
               }
          }]
     });
    
});
$(function() {
    $('#slider03').slick({ //メインのスライダーにしたい要素
          infinite: true, //スライドをループさせるか
          autoplay: true, //自動でスクロール
		  variableWidth: true,
    autoplaySpeed: 0, //自動再生のスライド切り替えまでの時間を設定
    speed: 3000, //スライドが流れる速度を設定
    cssEase: "linear", //スライドの流れ方を等速に設定
    slidesToShow: 1, //表示するスライドの数
    swipe: false, // 操作による切り替えはさせない
    arrows: false, //矢印非表示
    pauseOnFocus: false, //スライダーをフォーカスした時にスライドを停止させるか
    pauseOnHover: false, //スライダーにマウスホバーした時にスライドを停止させるか

          responsive: [{
               breakpoint: 768, // 横幅750px以下で挙動変更
                    settings: {
                         variableWidth: true,


						 autoplaySpeed: 0,
                         centerMode: false
               }
          }]
     });
    
});
$(function() {
    $('#slider04').slick({ //メインのスライダーにしたい要素
          infinite: true, //スライドをループさせるか
          autoplay: true, //自動でスクロール
		  variableWidth: true,
    autoplaySpeed: 0, //自動再生のスライド切り替えまでの時間を設定
    speed: 5000, //スライドが流れる速度を設定
    cssEase: "linear", //スライドの流れ方を等速に設定
    slidesToShow: 1, //表示するスライドの数
    swipe: false, // 操作による切り替えはさせない
    arrows: false, //矢印非表示
    pauseOnFocus: false, //スライダーをフォーカスした時にスライドを停止させるか
    pauseOnHover: false, //スライダーにマウスホバーした時にスライドを停止させるか
	rtl: true,

          responsive: [{
               breakpoint: 768, // 横幅750px以下で挙動変更
                    settings: {
                         variableWidth: true,
						 initialSlide: 1,
						 slidesToShow: 3,
						 autoplaySpeed: 1000,
                         centerMode: false
               }
          }]
     });
    
});



